import styled from 'styled-components';

import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $PanelHeading = styled.div<{
  $isActive: boolean;
  $gridTemplateColumns: string;
}>`
  font-weight: ${fontWeight('bold')};
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.mainTextColor : theme.colors.paragraphTextColor};
  text-align: left;
  background-color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.headerTitleColor : theme.colors.secondaryColor2};

  & div {
    padding: ${spacing('lg')};
  }

  display: grid;
  grid-template-columns: ${({ $gridTemplateColumns }) => {
    return $gridTemplateColumns;
  }};
`;

export const $AmountHeaderCel = styled.div`
  text-align: right;
  min-width: ${spacing(28)};
`;
